module.exports = "img/2.d24dc2.webp";